import React from 'react';
import { Category, ImageApi, Testimonial } from '@model/iceberg';
import { useAsync } from 'react-use';
import { TestimonialHero } from '@components/common/hero/testimonial/TestimonialHero';

interface TestimonialHeroContainerProps {
  testimonials?: Array<Testimonial>;
}

export const TestimonialHeroContainer = ({ testimonials }: TestimonialHeroContainerProps) => {
  const api: ImageApi = new ImageApi();
  const {
    value: image,
    error,
    loading
  } = useAsync(async () => {
    return await api.images({ category: Category.HUMAN, count: 1 });
  }, []);

  if (error || loading || !image?.images || !image?.images.length) return null;

  return <TestimonialHero testimonials={testimonials} image={image} />;
};
